import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

export interface BackgroundCheckUrl {
  url?: string;
  isOutbound?: boolean;
}

const URL = '/v2/background-check-url';

class BackgroundCheckUrlService {
  static create(
    data: { sitterId: number },
    config?: AxiosRequestConfig
  ): Promise<DataResponse<BackgroundCheckUrl>> {
    return axios.post(URL, data, config);
  }
}

export { BackgroundCheckUrlService };
